var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000112603577667411075930000017146216991371991182_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.User"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 266c124.3 0 225 100.7 225 225 0 11.6-9.4 21-21 21h-408c-11.6 0-21-9.4-21-21 0-124.3 100.7-225 225-225z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 128,
    r: 128
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon-person.07bde2e8a4f95bc8a26dc85a9f88d9cd.svg";
export { ForwardRef as ReactComponent };